import type React from 'react'
import styled from 'styled-components'

import Button from '@/components/Button'

interface Props {
  handleLogOut: Function
}

const DashboardInviteError = styled.div`
  display: grid;
  place-items: center;
  h1 {
    font-family: Montserrat, sans-serif;
    color: #34bebd;
  }
  a {
    color: #34bebd;
  }
`

const DashboardLoad: React.FC<Props> = ({ handleLogOut }) => {
  return (
    <DashboardInviteError>
      <h1>Invite has expired</h1>
      <p>Ooops it looks like that invite has either expired or is invalid.</p>
      <p>
        Please contact <a href="mailto:support@vouch.co.uk">support@vouch.co.uk</a> and we
        will get you up and running in no time.
      </p>
      <img
        src="/assets/svg/invalidinvite.svg"
        style={{ maxWidth: 400 }}
        alt="invalid invite"
      />
      <div className="side-by-side-center-flex">
        <Button $alternate>Try Again</Button>
        <Button onClick={() => handleLogOut()}>Log Out</Button>
      </div>
    </DashboardInviteError>
  )
}

export default DashboardLoad
